<wuc-button type="clean" modal-close-btn title="Sluit">
    <wuc-icon-ui icon="cross-closed"></wuc-icon-ui>
</wuc-button>
<h2 modal-title>Uw verzekering is beëindigd</h2>
<div modal-content>
    <h3>Krijgt u nog geld van ons?</h3>
    <p>
        Geen zorgen, rond de 26ste van de maand maken we de balans op en storten we terug (of verrekenen we) wat u nog
        tegoed heeft!
    </p>

    <h3>Bevestiging van uw opzegging</h3>
    <p>
        U heeft uw verzekering beëindigd, {{ lastDay }} is de laatste dag dat u verzekerd bent. Per e-mail sturen we u
        nog een bevestiging van uw opzegging.
    </p>
    <p *ngIf="crossSellProducts$ | async as crossSellProducts">
        <wuc-card padding="medium" cardStyle="tertiary">
            <span class="ins-insurance-end-product-success-modal__alert-content">
                <wuc-icon-ui
                    class="ins-insurance-end-product-success-modal__alert-icon"
                    size="s"
                    icon="emergency"
                ></wuc-icon-ui>
                <span>
                    <h5>Let op:</h5>
                    <p>
                        U heeft op {{ purchasedProduct?.product?.startDate | dateFormat }} bij uw
                        {{ purchasedProduct?.product?.productDescription }} ook een
                        <span *ngFor="let crossSell of crossSellProducts; last as isLast">
                            {{ crossSell?.product?.productDescription }}
                            <span *ngIf="!isLast">en</span>
                        </span>
                        afgesloten. Die ook opzeggen? U regelt het net zo eenvoudig als het opzeggen van uw
                        {{ purchasedProduct?.product?.productDescription }}. Maar natuurlijk mag u deze ook laten doorlopen!
                    </p>
                </span>
            </span>
        </wuc-card>
    </p>
    <h3>Uw eerlijke mening</h3>
    <p>Omdat we bij InShared graag willen leren van uw ervaring willen we u graag een paar korte vragen stellen.</p>
    <p>
        <wuc-link
            type="button-primary"
            url="https://survey.insocial.nl/swift/?sToken=bzt5tqhwwr&sId=6500"
            target="_blank"
            rel="noopener nofollow"
        >Ok, kom maar op
        </wuc-link>
    </p>
</div>
